<template>
  <v-container>
    <!-- Toolbar -->
    <v-app-bar app :color="isDark ? '#2A2A2A' : 'primary'" :dark="isDark">
      <!-- Back Button -->
      <v-btn icon @click="goToDocument" class="back-btn">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>
        <v-icon icon="mdi-book-open-page-variant"></v-icon>
        &nbsp; <strong>Page {{ page.number }}</strong>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="toggleTextDirection" title="Toggle text direction">
    <v-icon>
      {{ isRtl ? 'mdi-format-pilcrow-arrow-right' : 'mdi-format-pilcrow-arrow-left' }}
    </v-icon>
  </v-btn>

      <v-btn icon @click="openGlyphSettings" title="Transcription preview settings">
    <v-icon>mdi-format-font</v-icon>
  </v-btn>



      <v-btn icon @click="toggleDrawMode" title="Switch Draw Mode">
    <v-icon>
      {{ useMask ? 'mdi-vector-polyline' : 'mdi-rectangle-outline' }}
    </v-icon>
  </v-btn>
  <v-select
  v-model="selectedEncryption"
  :items="encryptionFilterOptions"
  item-title="text"
  item-value="value"
  label="Filter by encryption"
  dense
  outlined
  hide-details
  style="max-width: 220px; margin-left: 8px;"
/>
  <v-select
    v-model="selectedStatus"
    :items="statusFilterOptions"
    item-title="text"
    item-value="value"
    label="Filter by status"
    dense
    outlined
    hide-details
    style="max-width: 200px; margin-left: 16px;"
  ></v-select>
  <!-- Reload Segmentation Menu -->
      <v-menu
  v-model="reloadMenu"
  :close-on-content-click="false"
  offset-y
>
  <template v-slot:activator="{ props }">
    <v-btn
      color="white"
      class="toolbar-btn"
      v-bind="props"
    >
      <v-icon left>mdi-refresh</v-icon>
      Reload Segmentation
    </v-btn>
  </template>

  <v-card>
    <v-card-text>
      <v-text-field
        v-model="apiToken"
        label="eScriptorium API Token"
        outlined
        dense
        :type="showApiToken ? 'text' : 'password'"
        :append-icon="showApiToken ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="showApiToken = !showApiToken"
        hint="Configure in Preferences for persistent storage"
        persistent-hint
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text @click="reloadMenu = false">Cancel</v-btn>
      <v-btn
        color="primary"
        @click="reloadSegmentationWithToken"
        :disabled="!apiToken"
      >
        Reload
      </v-btn>
    </v-card-actions>
  </v-card>
</v-menu>
  <!-- Reload Transcription Menu -->
  <v-menu v-model="reloadTransMenu" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ props }">
      <v-btn color="white" class="toolbar-btn" v-bind="props">
        <v-icon left>mdi-refresh</v-icon>
        Reload Transcription
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-text-field
          v-model="apiToken"
          label="eScriptorium API Token"
          outlined
          dense
          :type="showApiToken ? 'text' : 'password'"
          :append-icon="showApiToken ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="showApiToken = !showApiToken"
          hint="Configure in Preferences for persistent storage"
          persistent-hint
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="reloadTransMenu = false">Cancel</v-btn>
        <v-btn
          color="primary"
          @click="reloadEscriptoriumTranscriptionWithToken"
          :disabled="!apiToken"
        >
          Reload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>

      <!-- Toggle Virtual Keyboard Button -->
      <v-btn
        :color="isVKEnabled ? 'success' : 'white'"
        class="toolbar-btn"
        @click="toggleVK"
      >
        <v-icon left>
          {{ isVKEnabled ? 'mdi-keyboard-off-outline' : 'mdi-keyboard-outline' }}
        </v-icon>
        {{ isVKEnabled ? 'Disable VK' : 'Enable VK' }}
      </v-btn>

      <!-- View Source in eScriptorium Button -->
      <v-tooltip
        :text="page.origin_url ? 'View in eScriptorium' : 'Source unavailable'"
        location="bottom"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            color="white"
            class="toolbar-btn"
            :disabled="!page.origin_url"
            :href="page.origin_url"
            target="_blank"
          >
            <img
              :src="require('@/assets/escriptorium.png')"
              width="20"
              height="20"
              class="me-2"
              :style="{ opacity: page.origin_url ? 1 : 0.3 }"
            />
            View Source
          </v-btn>
        </template>
      </v-tooltip>
    </v-app-bar>

    <!-- Lines -->
    <v-row v-if="filteredLines.length > 0">
      <v-col
        cols="12"
        v-for="(line, index) in displayedLines"
        :key="line.id"
        class="line-section"
      >
        <!-- Better looking card: slightly elevated, rounded corners, some margin -->
        <v-card
          class="fit-card my-custom-card"
          elevation="2"
          rounded="lg"
          outlined
        >
        <div class="card-header">
          <div class="line-title-row">
            <v-card-title class="line-title">
              Line #{{ line.id }}
            </v-card-title>
            <v-btn
              size="small"
              variant="tonal"
              color="primary"
              class="line-modal-btn"
              prepend-icon="mdi-text-box-edit-outline"
              title="Open the line editor"
              @click.stop="openLineModal(line)"
            >
              Edit line
            </v-btn>
          </div>
          <div class="status-and-encryption">
          <div class="toggles-container">
            <!-- Toggle Button -->
            <div class="toggle-arrow-btn">
              <v-btn
                icon
                size="small"
                color="primary"
                variant="tonal"
                @click.stop="toggleBubble(line.id)"
                class="bubble-toggle-btn"
              >
                <v-icon size="18">
                  {{ isBubbleExpanded(line.id) ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
                </v-icon>
              </v-btn>
            </div>

            <!-- Collapsible Bubble -->
            <div
              :class="['toggles-bubble', {
                'toggles-bubble--dark': isDark,
                'toggles-bubble--collapsed': !isBubbleExpanded(line.id)
              }]"
            >
              <!-- Encryption Toggle Buttons -->
              <v-btn-toggle
                :model-value="line.encryption_status"
                divided
                mandatory
                rounded="lg"
                density="comfortable"
                class="mr-4"
                @update:modelValue="val => onEncChange(line, val)"
              >
                <v-tooltip text="Encrypted" location="top">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" value="encrypted" @click.stop title="Encrypted" color="blue darken-2">
                      <v-icon size="24">mdi-lock</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
                <v-tooltip text="Mixed" location="top">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" value="mixed" @click.stop title="Mixed" color="blue darken-2">
                      <LockMixedIcon/>
                    </v-btn>
                  </template>
                </v-tooltip>

                <v-tooltip text="Plain text" location="top">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" value="clear_text" @click.stop title="Clear Text" color="blue darken-2">
                      <v-icon size="28">mdi-alphabetical-variant</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </v-btn-toggle>

              <!-- Transcription Status Icons -->
              <v-btn-toggle
                :model-value="line.status"
                density="comfortable"
                rounded="lg"
                divided
                mandatory
                class="mr-0"
                @update:modelValue="val => onStatusChange(line, val)"
              >
                <template v-for="option in statusOptions" :key="option.value">
                  <v-tooltip :text="`Mark as ${option.label}`" location="top">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        :value="option.value"
                        size="large"
                        density="comfortable"
                        :height="40"
                        :width="60"
                        icon
                        :disabled="!canChangeStatus(option.value)"
                        :color="line.status === option.value ? option.color : 'grey lighten-2'"
                      >
                        <v-icon size="28" :color="line.status === option.value ? 'white' : undefined">{{ option.icon }}</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </template>
              </v-btn-toggle>
            </div>
          </div>
          </div>
        </div>

          <!-- Cropped image placed in card text -->
          <v-card-text>
            <div class="preview-container">
    <canvas :ref="'canvas-' + line.id" class="line-canvas"></canvas>

            <!-- Inline glyph preview, rendered under the actual line image -->
            <div v-if="effectiveGlyphFontId" class="glyph-preview-row">
              <div class="glyph-preview-label">
                <v-icon size="14" class="mr-1">mdi-format-font</v-icon>
                Transcription preview
              </div>
              <canvas :ref="'glyph-canvas-' + line.id" class="glyph-line-canvas"></canvas>
            </div>
</div>

            <!-- Transcription Section -->
            <div class="transcription-section">
              <!-- Here we replace <textarea> with <v-textarea> for a better look -->
              <!-- 'auto-grow' will expand to fit content, 'rows="2"' is the minimum rows -->
              <div v-if="line.escriptorium_transcription" class="escriptorium-transcription-section">
    <v-textarea
      v-model="line.escriptorium_transcription"
      label="Escriptorium Transcription"
      variant="outlined"
      readonly
      dense
      auto-grow
      rows="1"
      class="escriptorium-transcription-box"
      min-width="1000"
    ></v-textarea>
    <!-- Small button to copy the escriptorium transcription into the editor -->
    <v-btn class="copy-btn" icon small @click="copyEscriptoriumToTranscription(line)" :disabled="line.status === 'validated'">
      <v-icon>mdi-content-copy</v-icon>
    </v-btn>
  </div>

              <v-textarea
                v-model="line.text_content"
                label="Transcribe this line"
                variant="outlined"
                density="comfortable"
                auto-grow
                rows="2"
                :dir="isRtl ? 'rtl' : 'ltr'"
                class="transcription-box display-virtual-keyboard"
                :class="{ 'validated-locked': line.status === 'validated' }"
                min-width="1000"
                :readonly="line.status === 'validated'"
                :append-inner-icon="line.status === 'validated' ? 'mdi-lock-check' : undefined"
                @blur="flushLine(line.id)"
                @keydown.enter.exact.prevent="saveLine(line)"
              ></v-textarea>
              <!-- Save Button -->
              <v-btn
                color="primary"
                class="save-btn"
                @click="saveLine(line)"
                :disabled="line.status === 'validated'"
              >
                Save
              </v-btn>
              <!-- Status: bottom-right -->
              <div class="line-save-status">
                <v-progress-circular
                  v-if="savingUI[line.id]"
                  indeterminate
                  :size="16"
                  :width="2"
                  color="primary"
                />
                <span v-if="savingUI[line.id]">Saving…</span>
                <span v-else>Last saved {{ formatHM(lastSavedAt(line.id)) }}</span>

                <!-- History Button - Small icon button -->
                <v-btn
                  icon
                  size="small"
                  variant="text"
                  color="grey-darken-1"
                  class="history-btn ml-1"
                  @click="openHistoryDialog(line.id)"
                  title="View line history"
                >
                  <v-icon size="18">mdi-history</v-icon>
                </v-btn>

                <v-btn
                  v-if="hasError(line.id)"
                  variant="text"
                  color="error"
                  density="compact"
                  @click="flushLine(line.id)"
                >
                  Retry
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Loading More Indicator -->
    <v-row v-if="isLoadingMore" class="my-4">
      <v-col cols="12" class="text-center">
        <v-progress-circular indeterminate color="primary" :size="40"></v-progress-circular>
        <p class="mt-2">Loading more lines...</p>
      </v-col>
    </v-row>

    <!-- Show count of displayed vs total filtered lines -->
    <v-row v-if="filteredLines.length > 0 && displayedLinesCount < filteredLines.length" class="my-2">
      <v-col cols="12" class="text-center">
        <v-chip color="primary" variant="outlined" class="mb-2">
          Showing {{ displayedLines.length }} of {{ filteredLines.length }} lines
          <v-icon end>mdi-chevron-down</v-icon>
        </v-chip>
        <p class="text-caption text-grey">Scroll down to load more</p>
        <v-btn
          variant="text"
          color="primary"
          size="small"
          @click="loadAllLines"
          class="mt-2"
        >
          <v-icon start>mdi-unfold-more-horizontal</v-icon>
          Load All ({{ filteredLines.length - displayedLines.length }} more)
        </v-btn>
      </v-col>
    </v-row>



 <!-- Empty State Message -->
 <v-container v-else-if="lines.length > 0" class="empty-state" fluid>
  <v-row justify="center" align="center">
    <v-col cols="12" class="text-center">
      <v-icon size="64" :color="isDark ? 'grey lighten-1' : 'grey darken-1'">
        mdi-alert-circle-outline
      </v-icon>
      <p class="empty-message">No lines match the selected filter.</p>
    </v-col>
  </v-row>
</v-container>
<v-container v-else class="empty-state" fluid>
  <v-row justify="center" align="center">
    <v-col cols="12" class="text-center">
      <v-icon size="64" :color="isDark ? 'grey lighten-1' : 'grey darken-1'">
        mdi-emoticon-sad-outline
      </v-icon>
      <p class="empty-message">No lines found. Try re-segmenting using Escriptorium if you imported the page from there.</p>
    </v-col>
  </v-row>
</v-container>
    <v-overlay :model-value="loading" class="align-center justify-center">
      <v-progress-circular color="primary" size="64" indeterminate></v-progress-circular>
    </v-overlay>


<!-- Line Editor Overlay -->
<LineTranscriptionModal
  v-model="lineModal"
  :line="modalLine"
  :lines="lines"
  :pageImage="page.image"
  :isRtl="isRtl"
  :vkEnabled="isVKEnabled"
  :readonly="modalLine ? modalLine.status === 'validated' : false"
  :statusOptions="statusOptions"
  :allowedStatuses="allowedStatuses"
  :glyphFont="effectiveGlyphFont"
  :glyphShowFade="glyphShowFade"
  :glyphShowMask="glyphShowMask"
  :projectId="$route.params.projectId"
  :documentId="$route.params.documentId"
  :pageId="$route.params.pageId"
  @update:text="setModalLineText"
  @update:status="val => modalLine && onStatusChange(modalLine, val)"
  @update:encryption="val => modalLine && onEncChange(modalLine, val)"
  @navigate="editLine"
  @toggle-vk="toggleVK"
  @revert="revertModalLine"
  @flush="modalLine && flushLine(modalLine.id)"
/>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="1000"
      color="success"
      top
      right
    >
      {{ snackbar.message }}
      <v-icon right color="white">mdi-check-circle</v-icon>
    </v-snackbar>

    <!-- Glyph Font Settings Dialog -->
    <LineGlyphPreview
      v-model="glyphSettingsDialog"
      :fonts="glyphFonts"
      :keyboards="glyphKeyboards"
      :fontId="effectiveGlyphFontId"
      :showFade="glyphShowFade"
      :showMask="glyphShowMask"
      :generating="glyphGenerating"
      :error="glyphError"
      @update:fontId="setGlyphFontId"
      @update:showFade="setGlyphShowFade"
      @update:showMask="setGlyphShowMask"
      @generate="generateGlyphFont"
      @clear-error="glyphError = ''"
    />

    <!-- Line History Dialog -->
    <LineHistoryDialog
      :isOpen="historyDialog"
      :lineId="historyLineId"
      :projectId="$route.params.projectId"
      :documentId="$route.params.documentId"
      :pageId="$route.params.pageId"
      :currentContent="getCurrentLineContent(historyLineId)"
      @close="closeHistoryDialog"
      @revert="revertLineContent"
    />
  </v-container>
</template>

<script>
import api from "@/plugins/axios";
import LockMixedIcon from './icons/LockMixedIcon.vue'
import LineHistoryDialog from './LineHistoryDialog.vue'
import LineGlyphPreview from './LineGlyphPreview.vue'
import LineTranscriptionModal from './LineTranscriptionModal.vue'
import { useAutoSave } from '@/composables/useAutoSave.js'
import { drawGlyphLine, dropGlyphFontFace, glyphFontFamily } from '@/plugins/glyphFont'
import "@haguili/virtual-keyboard/dist-lib/content.js";
export default {
  data() {
    return {
      savingUI: {},
    _savingTimers: {},
      _rafHandles: [], // track any requestAnimationFrame ids if added later
      autoSaves: {},
      _pageImg: null,
      selectedStatus: 'all',
      selectedEncryption: 'all',
      // Infinite scroll / pagination
      displayedLinesCount: 10,
      linesPerPage: 10,
      isLoadingMore: false,
    statusFilterOptions: [
      { text: 'All', value: 'all' },
      { text: 'Not Transcribed', value: 'not_transcribed' },
      { text: 'Transcribed', value: 'transcribed' },
      { text: 'Validated', value: 'validated' },
      { text: 'To Retranscribe', value: 'to_retranscribe' },
    ],
        encryptionFilterOptions: [
      { text: 'All', value: 'all' },
      { text: 'Encrypted', value: 'encrypted' },
      { text: 'Mixed', value: 'mixed' },
      { text: 'Plain text', value: 'clear_text' },
    ],
      isRtl: false,
      useMask: false,
      lineModal: false,
      modalLineId: null,
      reloadTransMenu: false,
      reloadMenu: false,
    apiToken: localStorage.getItem('prefs.escriptoriumToken') || '', // Load token from cache
    showApiToken: false, // Track visibility of API token
    snackbar: {
      show: false,
      message: "",
    },
      page: {},
      lines: [],
      loading: true,
      isVKEnabled: false,
      snackbar: {
        show: false,
        message: "",
      },
      toggleCooldown: null,
      cooldownMs: 500,
      disableInProgress: false,

      userRoles: JSON.parse(localStorage.getItem("roles") || "[]"),

      // Track collapsed state of toggle bubbles per line (inverted logic: default is expanded)
      expandedBubbles: new Set(),

      statusOptions: [
        {
          value: "not_transcribed",
          label: "Not Transcribed",
          icon: "mdi-close-circle-outline",
          color: "yellow darken-2",
        },
        {
          value: "transcribed",
          label: "Transcribed",
          icon: "mdi-check-circle-outline",
          color: "blue darken-2",
        },
        {
          value: "validated",
          label: "Validated",
          icon: "mdi-checkbox-marked-circle-auto-outline",
          color: "green darken-2",
        },
        {
          value: "to_retranscribe",
          label: "To Retranscribe",
          icon: "mdi-repeat-variant",
          color: "orange darken-2",
        },
      ],
encryptionOptions: [
  { value: "not_encrypted", label: "Not Encrypted", icon: "mdi-lock-open-outline", color: "grey" },
  { value: "encrypted",     label: "Encrypted",     icon: "mdi-lock-outline",       color: "red"  },
  { value: "mixed",         label: "Mixed",         icon: "mdi-lock-percent-outline", color: "blue" },
],

      // Line History Dialog
      historyDialog: false,
      historyLineId: null,

      // Glyph Font Settings — global, applied to every line
      glyphFonts: [],
      glyphKeyboards: [],
      glyphGenerating: false,
      glyphError: '',
      glyphSettingsDialog: false,
      glyphFontId: null, // sticky user choice; falls back to glyphFonts[0]
      glyphShowFade: true, // show the original line image underneath, faded
      glyphShowMask: true, // clip that underlay to the line's polygon mask
    };
  },
  components: { LockMixedIcon, LineHistoryDialog, LineGlyphPreview, LineTranscriptionModal },
  mounted() {
    this.setupSharedKeyboards();
    this.fetchPageDetails();
    this.fetchGlyphFonts();
    this.fetchGlyphKeyboards();
    console.log("Lines:", this.lines);
  this.$nextTick(() => {
    const textareas = document.querySelectorAll(".transcription-box textarea")
    console.log("Found plain textareas:", textareas.length);
  });

  // Add scroll listener for infinite scroll
  window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    this.cleanupAutoSaves()

    // Remove scroll listener
    window.removeEventListener('scroll', this.handleScroll);

    // 3. Detach virtual keyboards & listeners
    const textareas = document.querySelectorAll('.transcription-box textarea')
    textareas.forEach(ta => {
      try {
        ta.removeEventListener('input', this.handleVirtualInput)
        if (ta._virtualKeyboard && typeof ta._virtualKeyboard.detach === 'function') {
          ta._virtualKeyboard.detach()
        }
      } catch(e) { /* swallow */ }
    })

    // 4. Cancel any requestAnimationFrame handles (future-proof if added)
    if (this._rafHandles && this._rafHandles.length) {
      this._rafHandles.forEach(id => cancelAnimationFrame(id))
      this._rafHandles = []
    }

    // 5. Null large references to help GC
    this._pageImg = null
  },
  computed: {
  isDark() {
    return this.$vuetify.theme.global.current.dark;
  },
  filteredLines() {
    return this.lines.filter(line => {
      const statusOK = this.selectedStatus === 'all' || line.status === this.selectedStatus
      const encOK = this.selectedEncryption === 'all' || line.encryption_status === this.selectedEncryption
      return statusOK && encOK
    })
  },

  displayedLines() {
    // Return only the lines that should be displayed (first N lines based on scroll)
    return this.filteredLines.slice(0, this.displayedLinesCount)
  },

  hasMoreLines() {
    return this.displayedLinesCount < this.filteredLines.length
  },

  effectiveGlyphFontId() {
    return this.glyphFontId || (this.glyphFonts.length ? this.glyphFonts[0].id : null)
  },

  effectiveGlyphFont() {
    return this.glyphFonts.find(f => f.id === this.effectiveGlyphFontId) || null
  },

  modalLine() {
    return this.lines.find(l => l.id === this.modalLineId) || null
  },

  allowedStatuses() {
    return this.statusOptions
      .filter(option => this.canChangeStatus(option.value))
      .map(option => option.value)
  },

},
watch: {
  filteredLines() {
    // Reset displayed count when filters change
    this.displayedLinesCount = this.linesPerPage
    this.$nextTick(() => this.drawLines())
  },
},

  methods: {
    setupSharedKeyboards() {
      const { projectId } = this.$route.params;
      const isManager =
        this.userRoles.includes("administrator") ||
        this.userRoles.includes("project_leader");

      const opts = {
        // Shared keyboards — all authenticated users can fetch
        fetchFn: () =>
          api
            .get("/api/keyboards/shared/", { params: { project: projectId } })
            .then((r) => r.data),

        // Personal keyboards — all authenticated users
        fetchPersonalFn: () =>
          api.get("/api/keyboards/personal/").then((r) => r.data),
        savePersonalFn: (kb) =>
          api.put(`/api/keyboards/personal/${kb.id}/`, kb),
        saveToPersonalFn: (kb) =>
          api.post("/api/keyboards/personal/new/", kb),
        deletePersonalFn: (id) =>
          api.delete(`/api/keyboards/personal/${id}/delete/`),
      };

      // Only project leaders and admins can manage shared keyboards
      if (isManager) {
        opts.saveFn = (kb) =>
          api.put(`/api/keyboards/shared/${kb.id}/`, kb);
        opts.shareFn = (kb) =>
          api.post("/api/keyboards/shared/new/", { ...kb, project: projectId });
        opts.unshareFn = (id) =>
          api.delete(`/api/keyboards/shared/${id}/delete/`);
        opts.promoteToSharedFn = (kb) =>
          api.post("/api/keyboards/shared/promote/", {
            ...kb,
            project: projectId,
          });
      }

      if (typeof window.configureSharedKeyboards === "function") {
        window.configureSharedKeyboards(opts);
      } else {
        console.warn("configureSharedKeyboards not available on window");
      }
    },

handleScroll() {
  // Check if user scrolled near bottom
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;

  // If within 500px of bottom and not already loading, load more
  if (scrollTop + windowHeight >= documentHeight - 500) {
    this.loadMoreLines();
  }
},

loadMoreLines() {
  if (this.isLoadingMore || !this.hasMoreLines) return;

  this.isLoadingMore = true;

  // Simulate a small delay for smooth UX (optional)
  setTimeout(() => {
    this.displayedLinesCount += this.linesPerPage;
    this.isLoadingMore = false;

    // Draw the newly displayed lines
    this.$nextTick(() => {
      const image = this._pageImg;
      if (image) {
        const start = this.displayedLinesCount - this.linesPerPage;
        const newLines = this.displayedLines.slice(start);
        newLines.forEach(line => {
          if (this.useMask) this.drawLinesWithMask(image, line);
          else this.drawLineRect(image, line);
          this.renderGlyphPreview(line.id);
        });
      }
    });
  }, 100);
},

loadAllLines() {
  if (this.isLoadingMore) return;

  this.isLoadingMore = true;

  setTimeout(() => {
    this.displayedLinesCount = this.filteredLines.length;
    this.isLoadingMore = false;

    // Draw all lines
    this.$nextTick(() => {
      this.drawLines();
    });
  }, 100);
},

cleanupAutoSaves() {
  // 1. Clear all autosave timers
  Object.values(this._savingTimers || {}).forEach(t => t && clearTimeout(t))
  this._savingTimers = {}

  // 2. Unwatch per-line saving watchers
  Object.values(this.autoSaves || {}).forEach(entry => {
    try {
      entry.unwatchSaving && entry.unwatchSaving()
    } catch (_) {}
  })

  // 3. Clear the autoSaves object
  this.autoSaves = {}

  // 4. Clear savingUI
  this.savingUI = {}
},

initAutoSaves() {
  // Clean up any existing autosaves before reinitializing
  this.cleanupAutoSaves()

  const { projectId, documentId, pageId } = this.$route.params
  const enabled = () => JSON.parse(localStorage.getItem('prefs.autoSave') ?? 'true')

  this.lines.forEach(line => {
    const saveFn = (val) =>
      api.patch(
        `/api/projects/${projectId}/documents/${documentId}/pages/${pageId}/lines/${line.id}/update_text_content/`,
        { text_content: val }
      )

    const { saving, error, flush } = useAutoSave(
      () => line.text_content,
      saveFn,
      { enabled, debounceMs: 900, flushOnBlur: true, flushOnVisibilityChange: true }
    )

    // one autosave record per line
    const entry = this.autoSaves[line.id] = {
      saving,
      error,
      flush,                  // () => Promise|void
      lastSavedAt: null,
      showSaving: false,
      _startedAt: null,
      _hideTimer: null,
      unwatchSaving: null,
    }


entry.unwatchSaving = this.$watch(
  () => entry.saving.value,
  (now, was) => {
    const id = line.id
    if (now && !was) {
      // request started: show immediately
      this.savingUI[id] = true
      if (this._savingTimers[id]) clearTimeout(this._savingTimers[id])
    } else if (!now && was) {
      // request ended: hide exactly 2s after finish
      if (this._savingTimers[id]) clearTimeout(this._savingTimers[id])
      this._savingTimers[id] = setTimeout(() => {
        // if another save started in the meantime, do nothing
        if (!entry.saving.value) {
          this.savingUI[id] = false
          entry.lastSavedAt = new Date()
        }
      }, 1000)
    }
  }
)


  })
},


displaySaving(lineId) {
  const e = this.autoSaves[lineId]
  return e ? !!e.showSaving?.value : false
},
isSaving(lineId) {
  const e = this.autoSaves[lineId]
  return e ? !!e.saving?.value : false
},
isPending(lineId) {
  const e = this.autoSaves[lineId]
  return e ? !!e.pending : false
},
hasError(lineId) {
  const e = this.autoSaves[lineId]
  return e ? !!e.error?.value : false
},
lastSavedAt(lineId) {
  return this.autoSaves[lineId]?.lastSavedAt || null
},
formatHM(d) {
  if (!d) return '—'
  const dt = (d instanceof Date) ? d : new Date(d)
  return dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
},
async flushLine(lineId) {
  const entry = this.autoSaves[lineId]
  if (!entry?.flush) return

  // show immediately, and reset any previous hide timer
  this.savingUI[lineId] = true
  if (this._savingTimers[lineId]) clearTimeout(this._savingTimers[lineId])

  try {
    await entry.flush()
    if (this.effectiveGlyphFontId) this.renderGlyphPreview(lineId)
  } finally {
    // force the 2s hold even if the composable didn't flip its `saving` ref
    this._savingTimers[lineId] = setTimeout(() => {
      // if a newer save hasn’t started, hide
      if (!entry.saving.value) {
        this.savingUI[lineId] = false
        entry.lastSavedAt = new Date()
      }
    }, 1000)
  }
},


    openLineModal(line) {
      this.modalLineId = line.id;
      this.lineModal = true;
      if (!this.glyphFonts.length) this.fetchGlyphFonts();
    },

    editLine(direction) {
      if (!this.modalLine || !this.lines.length) return;
      const index = this.lines.findIndex(line => line.id === this.modalLine.id);
      const next = direction === 'next' ? index + 1 : index - 1;
      if (next < 0 || next > this.lines.length - 1) return;
      this.modalLineId = this.lines[next].id;
    },

    setModalLineText(value) {
      if (this.modalLine) this.modalLine.text_content = value;
    },

    async revertModalLine(content) {
      if (!this.modalLine) return;
      this.modalLine.text_content = content;
      await this.flushLine(this.modalLine.id);
      this.renderGlyphPreview(this.modalLine.id);
    },

    toggleTextDirection() {
      this.isRtl = !this.isRtl;
      console.log("Text direction toggled:", this.isRtl ? 'rtl' : 'ltr');
    },
    copyEscriptoriumToTranscription(line) {
      // Copy the content from escriptorium_transcription into the editable transcription (line.text_content)
      line.text_content = line.escriptorium_transcription;
      this.snackbar.message = "Copied Escriptorium transcription into the editor.";
      this.snackbar.show = true;
    },

    async fetchGlyphFonts() {
      try {
        const { projectId } = this.$route.params;
        const { data } = await api.get("/api/keyboards/fonts/", {
          params: { project: projectId },
        });
        this.glyphFonts = data;
        this.$nextTick(() => this.renderVisibleGlyphPreviews());
      } catch (e) {
        console.error("Error fetching keyboard fonts:", e);
      }
    },

    async fetchGlyphKeyboards() {
      try {
        const { projectId } = this.$route.params;
        const [shared, personal] = await Promise.all([
          api.get("/api/keyboards/shared/", { params: { project: projectId } }),
          api.get("/api/keyboards/personal/"),
        ]);
        this.glyphKeyboards = [
          ...shared.data.map((kb) => ({ ...kb, type: "shared" })),
          ...personal.data.map((kb) => ({ ...kb, type: "personal" })),
        ];
      } catch (e) {
        console.error("Error fetching keyboards:", e);
      }
    },

    openGlyphSettings() {
      this.glyphError = "";
      this.glyphSettingsDialog = true;
      if (!this.glyphFonts.length) this.fetchGlyphFonts();
      if (!this.glyphKeyboards.length) this.fetchGlyphKeyboards();
    },

    renderVisibleGlyphPreviews() {
      this.displayedLines.forEach((line) => this.renderGlyphPreview(line.id));
    },

    setGlyphFontId(fontId) {
      this.glyphFontId = fontId;
      this.$nextTick(() => this.renderVisibleGlyphPreviews());
    },

    setGlyphShowFade(val) {
      this.glyphShowFade = val;
      this.$nextTick(() => this.renderVisibleGlyphPreviews());
    },

    setGlyphShowMask(val) {
      this.glyphShowMask = val;
      this.$nextTick(() => this.renderVisibleGlyphPreviews());
    },

    async generateGlyphFont({ keyboardType, keyboardId }) {
      this.glyphGenerating = true;
      this.glyphError = "";
      try {
        const { data } = await api.post("/api/keyboards/fonts/generate/", {
          keyboard_type: keyboardType,
          keyboard_id: keyboardId,
        });
        dropGlyphFontFace(glyphFontFamily(data));
        await this.fetchGlyphFonts();
        this.setGlyphFontId(data.id);
      } catch (e) {
        console.error("Error generating keyboard font:", e);
        this.glyphError =
          e.response?.data?.error ||
          "Font generation failed. Does this keyboard have key images?";
      } finally {
        this.glyphGenerating = false;
      }
    },

    async renderGlyphPreview(lineId) {
      const line = this.lines.find((l) => l.id === lineId);
      const fontId = this.effectiveGlyphFontId;
      if (!line || !fontId) return;

      await this.$nextTick();
      const canvasRefs = this.$refs["glyph-canvas-" + lineId];
      const canvas = Array.isArray(canvasRefs) ? canvasRefs[0] : canvasRefs;
      if (!canvas) return;

      const lineCanvasRefs = this.$refs["canvas-" + lineId];
      const lineCanvas = Array.isArray(lineCanvasRefs)
        ? lineCanvasRefs[0]
        : lineCanvasRefs;

      let image = null;
      if (this.glyphShowFade && line.mask?.length) {
        image = await this.ensurePageImage();
      }

      await drawGlyphLine(canvas, {
        font: this.glyphFonts.find((f) => f.id === fontId),
        text: line.text_content || "",
        isRtl: this.isRtl,
        width: lineCanvas?.width || 1000,
        height: lineCanvas?.height || 140,
        image,
        mask: line.mask,
        clipToMask: this.glyphShowMask,
      });
    },

    // Line History Methods
    openHistoryDialog(lineId) {
      this.historyLineId = lineId;
      this.historyDialog = true;
    },

    closeHistoryDialog() {
      // Close immediately for better perceived performance
      this.historyDialog = false;
      this.historyLineId = null;
    },

    getCurrentLineContent(lineId) {
      if (!lineId) return '';
      const line = this.lines.find(l => l.id === lineId);
      return line ? line.text_content : '';
    },

    async revertLineContent(content) {
      if (!this.historyLineId) return;

      const line = this.lines.find(l => l.id === this.historyLineId);
      if (line) {
        line.text_content = content;
        try {
          await this.saveLine(line);
          this.snackbar.message = "Successfully reverted to previous version.";
          this.snackbar.show = true;
        } catch (error) {
          console.error('Error reverting line content:', error);
          this.snackbar.message = "Failed to revert line content.";
          this.snackbar.show = true;
        }
      }
    },

    toggleBubble(lineId) {
      if (this.expandedBubbles.has(lineId)) {
        this.expandedBubbles.delete(lineId);
      } else {
        this.expandedBubbles.add(lineId);
      }
      // Trigger reactivity
      this.$forceUpdate();
    },

    isBubbleExpanded(lineId) {
      // Default to expanded (true) if not in the set, collapsed (false) if explicitly added to set
      return !this.expandedBubbles.has(lineId);
    },

    async reloadEscriptoriumTranscriptionWithToken() {
      if (!this.apiToken) {
        this.snackbar.message = "API Token is required!";
        this.snackbar.show = true;
        return;
      }
      try {
        const { projectId, documentId, pageId } = this.$route.params;
        const response = await api.post(
          `/api/projects/${projectId}/documents/${documentId}/pages/${pageId}/reload_escriptorium_transcription/`,
          { api_token: this.apiToken }
        );
        console.log("Escriptorium transcription reloaded:", response.data);
        this.snackbar.message = "Transcriptions reloaded successfully!";
        this.snackbar.show = true;
        this.reloadTransMenu = false; // Close the menu
        await this.fetchPageDetails();
      } catch (error) {
        console.error("Error reloading escriptorium transcription:", error);
        this.snackbar.message = "Failed to reload escriptorium transcription.";
        this.snackbar.show = true;
      }
    },
      onEncChange(line, val) {
    const prev = line.encryption_status
    line.encryption_status = val
    this.updateEncryptionStatus(line, val).catch(() => {
      line.encryption_status = prev
    })
  },
    async updateEncryptionStatus(line, newStatus) {
  if (!this.canChangeStatus(newStatus)) {
    return;
  }
  try {
    const { projectId, documentId, pageId } = this.$route.params;
    // PATCH the line with the new encryption_status value
    await api.patch(
      `/api/projects/${projectId}/documents/${documentId}/pages/${pageId}/lines/${line.id}/`,
      { encryption_status: newStatus }
    );
    line.encryption_status = newStatus;
    this.snackbar.message = `Encryption status updated to '${newStatus}'!`;
    this.snackbar.show = true;
  } catch (error) {
    console.error("Error updating encryption status:", error);
    this.snackbar.message = "Failed to update encryption status.";
    this.snackbar.show = true;
  }
},
    patchValueSetter(element) {
  // Get the original property descriptor from HTMLTextAreaElement.prototype
  const descriptor = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, "value");
  if (!descriptor || !descriptor.set) {
    console.warn("Could not find the native setter for value.");
    return;
  }

  // Create a flag to avoid recursive calls
  let isSetting = false;

  // Save the current value so we can compare
  let currentValue = element.value;

  Object.defineProperty(element, "value", {
    configurable: true,
    enumerable: true,
    get() {
      return descriptor.get.call(this);
    },
    set(newVal) {
      // Prevent recursion if we are already setting
      if (isSetting) {
        descriptor.set.call(this, newVal);
        currentValue = newVal;
        return;
      }
      // Only proceed if the new value is different
      if (newVal === currentValue) return;

      isSetting = true;
      // Call the original setter
      descriptor.set.call(this, newVal);
      currentValue = newVal;
      // Dispatch an InputEvent so that Vue’s v-model notices the change
      this.dispatchEvent(new InputEvent("input", { bubbles: true }));
      isSetting = false;
    }
  });
},
    saveApiToken() {
    if (this.apiToken) {
      localStorage.setItem('prefs.escriptoriumToken', this.apiToken);
      this.snackbar.message = "eScriptorium API Token saved to preferences!";
      this.snackbar.show = true;
    } else {
      this.snackbar.message = "Please provide a valid API Token.";
      this.snackbar.show = true;
    }
  },
  async reloadSegmentationWithToken() {
  if (!this.apiToken) {
    this.snackbar.message = "API Token is required!";
    this.snackbar.show = true;
    return;
  }

  try {
    const { projectId, documentId, pageId } = this.$route.params;
    const response = await api.post(
      `/api/projects/${projectId}/documents/${documentId}/pages/${pageId}/reload_segmentation/`,
      {
        api_token: this.apiToken,
      }
    );
    console.log("Segmentation reloaded with token:", response.data);

    this.snackbar.message = "Segmentation reloaded successfully!";
    this.snackbar.show = true;
    this.reloadMenu = false; // Close the menu

    await this.fetchPageDetails();
  } catch (error) {
    console.error("Error reloading segmentation with token:", error);

    this.snackbar.message = "Failed to reload segmentation.";
    this.snackbar.show = true;
  }
},


    async fetchPageDetails() {
      try {
        const { projectId, documentId, pageId } = this.$route.params;
        const response = await api.get(
          `/api/projects/${projectId}/documents/${documentId}/pages/${pageId}/`
        );
        this.page = response.data;
        this.lines = (this.page.lines || []).sort((a, b) => a.order - b.order);
        this.initAutoSaves();
        this.drawLines();
      } catch (error) {
        console.error("Error fetching page details:", error);
      } finally {
        this.loading = false;
      }
    },
    toggleDrawMode() {
  this.useMask = !this.useMask;
  this.drawLines();
},

  async ensurePageImage() {
    if (this._pageImg && this._pageImg.src === this.page.image) return this._pageImg
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.src = this.page.image
    await new Promise(res => (img.onload = res))
    this._pageImg = img
    return img
  },

  async drawLines() {
    if (!this.page?.image) return
    const image = await this.ensurePageImage()
    this.displayedLines.forEach(line => {
      if (this.useMask) this.drawLinesWithMask(image, line)
      else this.drawLineRect(image, line)
    })
    this.$nextTick(() => this.renderVisibleGlyphPreviews())
  },
  drawLinesWithMask(image, line) {
  const canvas = this.$refs[`canvas-${line.id}`][0];
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  if (!line.mask || !line.mask.length) return;

  const xs = line.mask.map(pt => pt[0]);
  const ys = line.mask.map(pt => pt[1]);
  const minX = Math.min(...xs);
  const minY = Math.min(...ys);
  const maxX = Math.max(...xs);
  const maxY = Math.max(...ys);
  const cropWidth = maxX - minX;
  const cropHeight = maxY - minY;


  const scale = line.scale || 1;
  canvas.width = cropWidth * scale;
  canvas.height = cropHeight * scale;
  ctx.save();
  ctx.scale(scale, scale);
  ctx.translate(-minX, -minY);
  ctx.beginPath();
  line.mask.forEach(([x, y], i) => {
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  });
  ctx.closePath();
  ctx.clip();
  ctx.drawImage(image, 0, 0);
  ctx.restore();
},
drawLineRect(image, line) {
  const canvas = this.$refs[`canvas-${line.id}`][0];
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  if (!line.mask || !line.mask.length) return;

  const xs = line.mask.map(pt => pt[0]);
  const ys = line.mask.map(pt => pt[1]);
  const minX = Math.min(...xs);
  const minY = Math.min(...ys);
  const maxX = Math.max(...xs);
  const maxY = Math.max(...ys);
  const rectWidth = maxX - minX;
  const rectHeight = maxY - minY;


  const scale = line.scale || 1;

  canvas.width = rectWidth * scale;
  canvas.height = rectHeight * scale;

  ctx.drawImage(image, minX, minY, rectWidth, rectHeight, 0, 0, rectWidth * scale, rectHeight * scale);
},


    toggleVK() {
      if (this.toggleCooldown) {
        console.warn("Preventing immediate re-toggle: cooldown is active.");
        return;
      }
      if (!this.isVKEnabled) {
        this.isVKEnabled = true;
        this.enableAllTextareas();
      } else {
        this.isVKEnabled = false;
        this.disableAllTextareas();
        this.disableInProgress = true;
        this.toggleCooldown = setTimeout(() => {
          this.disableInProgress = false;
          this.toggleCooldown = null;
        }, this.cooldownMs);
      }
    },

    enableAllTextareas() {
  const textareas = document.querySelectorAll(".transcription-box textarea")


  console.log("Found plain textareas:", textareas.length);
  textareas.forEach((ta) => this.activateVK(ta));
},

    disableAllTextareas() {
      const textareas = document.querySelectorAll(".transcription-box textarea")


      textareas.forEach((ta) => this.deactivateVK(ta));
      console.log("Virtual keyboard disabled for textareas.");
    },

    activateVK(textarea) {
  console.debug("Activating VK on:", textarea);
  // Remove any previous onfocus handler
  textarea.onfocus = null;
  if (textarea._virtualKeyboard) {
    try {
      textarea._virtualKeyboard.detach();
    } catch (err) {
      console.warn("Error forcibly detaching old VK:", err);
    }
    textarea._virtualKeyboard = null;
  }
  setTimeout(() => {
    // Enable the virtual keyboard (this updates the DOM value)
    enableVirtualKeyboard(textarea);


    // Patch the textarea so that any change to its value dispatches an input event
    this.patchValueSetter(textarea);
    // Optionally, update a dataset property so your handleVirtualInput can know which line this is
    textarea.dataset.prevValue = textarea.value || "";
    // Remove any previous event listener (to avoid duplicates)
    textarea.removeEventListener("input", this.handleVirtualInput);
    textarea.addEventListener("input", this.handleVirtualInput);
  }, 50);
},

    deactivateVK(textarea) {
      console.debug("Deactivating VK on:", textarea);
      try {
        if (textarea._virtualKeyboard) {
          textarea._virtualKeyboard.detach();
        }
      } catch (err) {
        console.warn("Error detaching VK:", err);
      }
      textarea.onfocus = (e) => {
        e.preventDefault();
      };
      textarea.removeEventListener("input", this.handleVirtualInput);
      if (textarea._virtualKeyboard) {
        textarea._virtualKeyboard = null;
      }
    },

    handleVirtualInput(e) {
  const input = e.target;
  console.debug("Teklia changed the value to:", input.value);

  const index = input.getAttribute('data-line-index');
  if (index !== null) {
    this.lines[Number(index)] = {
      ...this.lines[Number(index)],
      text_content: input.value
    };
  }

  // Force the component to re-render (Vue 3 rarely needs this, but you can try):
  this.$forceUpdate();

  //input.dispatchEvent(new InputEvent("input", { bubbles: true }));
},


async saveLine(line) {
  try {
    await this.flushLine(line.id)
    this.snackbar.message = "Transcription saved!"
    this.snackbar.show = true
  } catch (err) {
    console.error("Error saving line:", err)
    this.snackbar.message = "Failed to save transcription."
    this.snackbar.show = true
  }
},


    // Permission check
    canChangeStatus(statusValue) {
      if (
        this.userRoles.includes("administrator") ||
        this.userRoles.includes("project_leader")
      ) {
        return true;
      } else if (this.userRoles.includes("transcriber")) {
        return (
          statusValue === "not_transcribed" || statusValue === "transcribed"
        );
      }
      return false;
    },

    // Update line's status
    async updateStatus(line, newStatus) {
      if (!this.canChangeStatus(newStatus)) {
        return;
      }
      try {
        const { projectId, documentId, pageId } = this.$route.params;
        await api.patch(
          `/api/projects/${projectId}/documents/${documentId}/pages/${pageId}/lines/${line.id}/`,
          { status: newStatus }
        );
        line.status = newStatus;
        this.snackbar.message = `Line status updated to '${newStatus}'!`;
        this.snackbar.show = true;
      } catch (error) {
        console.error("Error updating line status:", error);
        this.snackbar.message = "Failed to update line status.";
        this.snackbar.show = true;
      }
    },
      onStatusChange(line, val) {
    if (!this.canChangeStatus(val)) return
    const prev = line.status
    // Optimistic UI
    line.status = val
    this.updateStatus(line, val).catch(() => {
      // Revert if API call fails
      line.status = prev
    })
  },
    goToDocument() {
      const { projectId, documentId } = this.$route.params;
      this.$router.push(`/projects/${projectId}/documents/${documentId}`);
    },
  },
};
</script>

<style scoped>
/* Validated (locked) transcription field */
.validated-locked {
  opacity: 0.65;
}
.validated-locked :deep(.v-field__input textarea) {
  cursor: default !important;
}

/* Card styling */
.my-custom-card {
  margin-bottom: 20px; /* Add space between cards */
  background-color: rgb(var(--v-theme-surface));
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.v-theme--dark .my-custom-card {
  border-color: rgba(255, 255, 255, 0.18) !important;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.06) !important;
}

/* Title styling (optional) */
.line-title {
  font-weight: 600;
  font-size: 1.1rem;
  color: rgb(var(--v-theme-on-surface));
}

.line-title-row {
  display: flex;
  align-items: center;
}

.line-modal-btn {
  opacity: 0.7;
}

.line-modal-btn:hover {
  opacity: 1;
}

.line-image {
  margin-bottom: 10px;
}

.line-canvas {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  display: block;
  max-width: 100%;
  min-height: 50px;
}

/* We place everything in v-card-text or v-card-subtitle. */
.transcription-section {
  display: flex;
  align-items: flex-start; /* ensures textareas align top */
  gap: 10px;
  margin-top: 10px;
}

/* Our v-textarea can still have .transcription-box for VK targeting */
.transcription-box {
  width: 100%;
  max-width: 500px; /* Adjust as you wish */
}

/* Keep the Save button from wrapping */
.save-btn {
  white-space: nowrap;
}

/* History button styling */
.history-btn {
  white-space: nowrap;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.history-btn:hover {
  opacity: 1;
}

.status-icons {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.status-icon {
  display: inline-block;
}
::v-deep #teklia-virtual-keyboard .key-button {
  background-color: rgba(var(--v-border-color), 0.3) !important;
  border: 1px solid rgba(var(--v-border-color), 0.4) !important;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
}

.status-and-encryption {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  margin-right: 10px;
}

.status-icons {
  display: flex;
  align-items: center;
}
.transcription-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}


.transcription-box,
.escriptorium-transcription-box {
  width: 100%;
  margin-top: 10px;
}

.escriptorium-transcription-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
.copy-btn {
  min-width: 24px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(var(--v-theme-on-surface)) !important;
  background-color: rgba(var(--v-border-color), 0.12) !important;
}

.glyph-preview-row {
  margin-top: 10px;
}

.glyph-preview-label {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
  margin-bottom: 4px;
}

.glyph-line-canvas {
  display: block;
  max-width: 100%;
  min-height: 50px;
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px; /* Adjust as necessary */
  color: var(--v-theme-on-background); /* Automatically adapts to light/dark theme */
  opacity: 0.7; /* Subtle faded effect */
}

.empty-message {
  font-size: 1.2rem;
  margin-top: 16px;
  color: inherit;
}

.preview-container {
  position: relative;
}

.preview-btn {
  position: absolute;
  top: 5px;         /* Adjust as needed */
  right: 5px;       /* Adjust as needed */
  background-color: rgba(128, 128, 128, 0.3); /* Semi-transparent grey */
  border-radius: 50%;
  z-index: 10;      /* Ensure it appears on top of the canvas */
  transition: background-color 0.3s;
}

.preview-btn:hover {
  background-color: rgba(128, 128, 128, 0.6);
}


.preview-close-btn {
  position: relative;
  z-index: 1000;
}

.preview-image {
  position: relative;
  min-height: 100%;
  min-width: 100%;
}

.preview-container {
  position: relative;
  display: inline-block; /* Container fits the canvas exactly */
}

.line-canvas {
  display: block;
}

/* .overlay-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: rgba(128, 128, 128, 0.3);
  border-radius: 50%;
  z-index: 10;
  transition: background-color 0.3s;
  padding: 2px;
  width: 30px;
  height: 30px;
}

.overlay-btn:hover {
  background-color: rgba(128, 128, 128, 0.6);
}

.overlay-btn .v-icon {
  font-size: 16px;
} */


.overlay-content {
  position: relative;
  margin-top: 500px;
  margin-left: 500px;
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.v-overlay__scrim {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
/* Toggles container */
.toggles-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-arrow-btn {
  display: flex;
  align-items: center;
}

.bubble-toggle-btn {
  transition: transform 0.2s ease, background-color 0.2s ease;
  border-radius: 8px !important;
}

.bubble-toggle-btn:hover {
  transform: scale(1.05);
}

.toggles-bubble {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 14px;
  background: #f2f3f5;                 /* light gray */
  border: 1px solid rgba(0,0,0,0.08);   /* subtle outline */
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
  transition: all 0.3s ease;
  overflow: hidden;
  max-width: 100%;
  opacity: 1;
}

.toggles-bubble--collapsed {
  max-width: 0;
  padding-left: 0;
  padding-right: 0;
  opacity: 0;
  transform: translateX(-10px);
  pointer-events: none;
}

.toggles-bubble--dark {
  background: rgba(255,255,255,0.06);   /* dark mode-friendly */
  border-color: rgba(255,255,255,0.14);
  box-shadow: 0 2px 8px rgba(0,0,0,0.25);
}
.line-save-status {
  margin-top: 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-end;    /* pushes to right within the column */
  margin-left: auto;       /* ensures right alignment in your flex column */
  color: rgba(var(--v-theme-on-surface), 0.6);
}

/* Smooth scroll behavior */
html {
  scroll-behavior: smooth;
}


</style>
